import CommunityConnector from '../../models/CommunityModels';
import { post } from './ApiWrapper';
import useCustomMutation from '../useCustomMutation';

export const chatApiBasePath = 'ChatApi';

export const getChatUserToken = async (): Promise<string> => {
	return post(`${chatApiBasePath}/Token`, null);
};

const updateOrCreateChatUsers = async (selectedConnectors: CommunityConnector[]): Promise<unknown> => {
	return post(`${chatApiBasePath}/Users`, selectedConnectors);
};
export const useUpdateOrCreateChatUsers = (onSuccess: (selectedConnectors: CommunityConnector[]) => Promise<void>) => {
	return useCustomMutation({
		mutationFn: (selectedConnectors: CommunityConnector[]) => updateOrCreateChatUsers(selectedConnectors),
		onSuccess: async (data: unknown, variables: CommunityConnector[]) => onSuccess(variables) // variables is the as selectedConnectors in mutationFn
	});
};
